import React from "react";
import { normalizeProps } from "./utils/normalizeProps";

const EncaminhamentoIcon = (props) => {
  return (
    <svg
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...normalizeProps(props)}
    >
      <path
        d="M0 2.75C0 1.23122 1.30584 0 2.91667 0H13.75C15.3608 0 16.6667 1.23122 16.6667 2.75V7.22811C15.4166 6.62558 14.0004 6.28571 12.5 6.28571C7.43739 6.28571 3.33333 10.1553 3.33333 14.9286C3.33333 17.8517 4.87241 20.4359 7.2282 22H2.91667C1.30584 22 0 20.7688 0 19.25V2.75ZM5 3.14286C4.07953 3.14286 3.33333 3.84641 3.33333 4.71429C3.33333 5.58216 4.07953 6.28571 5 6.28571H11.6667C12.5871 6.28571 13.3333 5.58216 13.3333 4.71429C13.3333 3.84641 12.5871 3.14286 11.6667 3.14286H5ZM20 14.9286C20 18.834 16.6421 22 12.5 22C8.35786 22 5 18.834 5 14.9286C5 11.0231 8.35786 7.85714 12.5 7.85714C16.6421 7.85714 20 11.0231 20 14.9286ZM11.9101 18.6264L11.9143 18.6303C11.9934 18.704 12.0842 18.7597 12.181 18.7975C12.2778 18.8354 12.3838 18.8565 12.495 18.8571L12.5 18.8571L12.505 18.8571C12.6162 18.8565 12.7222 18.8354 12.819 18.7975C12.9173 18.7592 13.0094 18.7023 13.0893 18.627L16.4226 15.4842C16.748 15.1773 16.748 14.6798 16.4226 14.373C16.0972 14.0661 15.5695 14.0661 15.2441 14.373L13.3333 16.1745V11.7857C13.3333 11.3518 12.9602 11 12.5 11C12.0398 11 11.6667 11.3518 11.6667 11.7857V16.1745L9.75592 14.373C9.43048 14.0661 8.90285 14.0661 8.57741 14.373C8.25197 14.6798 8.25197 15.1773 8.57741 15.4842L11.9101 18.6264Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default EncaminhamentoIcon;
